import React from 'react';
import { render } from 'react-dom';

import Picture from '../react/Picture';

export default class PictureRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model } = this.context.dataset;
    if (!model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(
      <Picture
        {...jsonModel.image}
        className="Picture"
        sizes={[
          [100], // from 0
          [100], // from 440
          [80], // from 768
          [60], // from 1024
          ['880'], // from 1440
        ]}
      />,
      this.context
    );
  }
}
